/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compliance_Template_Field_Action_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Choose action" |
*
* @param {Compliance_Template_Field_Action_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const compliance_template_field_action_placeholder = /** @type {((inputs?: Compliance_Template_Field_Action_PlaceholderInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compliance_Template_Field_Action_PlaceholderInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Aktion wählen")
	return /** @type {LocalizedString} */ ("Choose action")
});